// Slide-over drawer that mounts ManualReader. Summoned from anywhere
// in the app — FTUE, help buttons, etc. — without taking the user
// out of their current screen. The /manual route handles deep
// linking; the drawer is component-state only (no URL change).
//
// StrictMode trap (CLAUDE.md): no side-effects with persistent UI
// consequences in unmount paths. The Esc listener attach/detach is
// purely local DOM state, safe under StrictMode's double-mount.

import React, { useEffect } from 'react';

import ManualReader from './ManualReader';
import { MANUAL_TEXT } from './_manual.generated';
import './ManualDrawer.css';


function ManualDrawer(props) {
    const { open, initialSlug, onClose } = props;

    useEffect(() => {
        if (!open) {
            return undefined;
        }
        function handleKey(event) {
            if (event.key === 'Escape' && typeof onClose === 'function') {
                onClose();
            }
        }
        window.addEventListener('keydown', handleKey);
        return () => {
            window.removeEventListener('keydown', handleKey);
        };
    }, [open, onClose]);

    if (!open) {
        return null;
    }

    function handleBackdropClick() {
        if (typeof onClose === 'function') {
            onClose();
        }
    }

    function handlePanelClick(event) {
        event.stopPropagation();
    }

    return (
        <div
            className="manual-drawer-backdrop"
            role="presentation"
            onClick={handleBackdropClick}
        >
            <aside
                className="manual-drawer-panel"
                role="dialog"
                aria-label="HSHM Rule Book"
                onClick={handlePanelClick}
            >
                <header className="manual-drawer-header">
                    <div className="manual-drawer-title">
                        HSHM Rule Book
                    </div>
                    <button
                        type="button"
                        className="manual-drawer-close"
                        aria-label="Close manual"
                        onClick={() => onClose && onClose()}
                    >
                        ×
                    </button>
                </header>
                <div className="manual-drawer-body">
                    <ManualReader
                        markdown={MANUAL_TEXT}
                        initialSlug={initialSlug}
                    />
                </div>
            </aside>
        </div>
    );
}

export default ManualDrawer;
